/* eslint-disable no-unused-vars */
import React, { useContext, useState, useCallback } from 'react';
import './style.scss';
import User from './user';
import Emp from './emp';
import Logs from './logs';

export default function Administrativo() {
  const [tab, setTab] = useState(0);

  return (
    <div className="Administrativo">
      <div className="Content">
        <div className="hotbar">
          <button
            onClick={() => {
              setTab(0);
            }}
            className={`${tab === 0 && 'active'}`}
          >
            Usuários
          </button>
          <button
            onClick={() => {
              setTab(1);
            }}
            className={`${tab === 1 && 'active'}`}
          >
            Empresas
          </button>
          <button
            onClick={() => {
              setTab(2);
            }}
            className={`${tab === 2 && 'active'}`}
          >
            Logs
          </button>
        </div>

        <User Disabled={tab !== 0} />
        <Emp Disabled={tab !== 1} />
        <Logs Disabled={tab !== 2} />
      </div>
    </div>
  );
}
